import React from "react";
import PropTypes from "prop-types";
import { Label, Input, FormFeedback } from "reactstrap";

const numericKeyPress = (event) => {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};

// "Pick existing" isn't offered here: that flow (available-contacts) needs
// an already-saved client id to exclude itself, which doesn't exist yet
// during creation — it's edit-time only (see ClientDetail.js). So this step
// keeps exactly the "create new" second client that already existed on the
// old Client Accounts tab, just presented with the mockup's card chrome.
const LinkedStep = ({ validation }) => {
  const linked = !!validation.values.add_second_client;

  const field = (key, label, placeholder, opts = {}) => {
    const touched = validation.touched[key];
    const error = validation.errors[key];
    const invalid = !!(touched && error);
    return (
      <div className="col-md-6" key={key}>
        <Label htmlFor={`${key}-field`} className="form-label">
          {label}
        </Label>
        <Input
          name={key}
          id={`${key}-field`}
          className="form-control"
          placeholder={placeholder}
          type={opts.type || "text"}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          onKeyPress={opts.numericOnly ? numericKeyPress : undefined}
          value={validation.values[key] || ""}
          invalid={invalid}
        />
        {invalid && <FormFeedback type="invalid">{error}</FormFeedback>}
      </div>
    );
  };

  if (!linked) {
    return (
      <div>
        <div className="text-muted mb-3" style={{ fontSize: 12.5 }}>
          Optionally link one secondary client to this record — a spouse or
          co-buyer who signs alongside.
        </div>
        <button
          type="button"
          onClick={() => validation.setFieldValue("add_second_client", true)}
          className="btn btn-outline-primary w-100"
          style={{ borderStyle: "dashed" }}
        >
          + Link a secondary client
        </button>
      </div>
    );
  }

  return (
    <div className="border rounded-3" style={{ background: "var(--vz-light)", padding: "14px 15px" }}>
      <div className="d-flex align-items-center mb-3">
        <span
          className="text-uppercase text-muted"
          style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: 0.8 }}
        >
          Linked client
        </span>
        <button
          type="button"
          onClick={() => validation.setFieldValue("add_second_client", false)}
          title="Remove linked client"
          className="btn btn-sm btn-outline-danger ms-auto"
        >
          <i className="ri-close-line"></i>
        </button>
      </div>

      <div className="row gy-3">
        {field("additional_contact2_name", "First Name", "Enter First Name")}
        {field("additional_contact2_surname", "Last Name", "Enter Last Name")}
        {field("additional_contact2_ssn", "Social Security Number", "Enter Social Security Number", {
          numericOnly: true,
        })}
        {field(
          "additional_contact2_ssn_series",
          "Social Security Series (optional)",
          "Enter Social Security Series"
        )}
        {field("additional_contact2_mobile", "Mobile Phone Number", "Enter Mobile Phone Number", {
          numericOnly: true,
        })}
        {field("additional_contact2_email", "Email", "Enter Email", { type: "email" })}
      </div>

      <div className="alert alert-info mt-3 mb-0">
        <i className="ri-information-line me-2"></i>
        The second client will share the same address as the primary client.
      </div>
    </div>
  );
};

LinkedStep.propTypes = {
  validation: PropTypes.object.isRequired,
};

export default LinkedStep;
